/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: app.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import type { FunctionComponent } from 'react';

import PublicRoutes from '@/routes/public.routes';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const TranscadOrgSite: FunctionComponent = () => {
  return <PublicRoutes />;
};

export default TranscadOrgSite;
